import { call, put, select } from 'redux-saga/effects'

import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'
import PaymentV2 from 'common/modules/paymentv2'

import { creators } from 'common/modules/arbiter/actions'
import selectors from 'common/modules/arbiter/selectors'

import { handleArticle } from './loaderActions'

export function* watchLoaderSuccess({ payload: { scope = 'guest' } }) {
    const {
        events,
        initializeDecorators = () => {},
        updateDecorators = () => {},
        adBlockDetector,
    } = yield select(Zoid.selectors.getXprops)

    const loader = yield select(Loader.selectors.loader)
    const scopedLoader = loader[scope]

    if (scope === 'user') {
        const publisherId = yield select(Loader.selectors.publisherId)

        yield put(
            yield call(PaymentV2.creators.getPayments, {
                payload: {
                    publisherId,
                },
            }),
        )
    }

    const haveAllFrameInitialized = yield select(selectors.haveAllFrameInitialized)

    if (haveAllFrameInitialized) {
        yield put(Internal.creators.sendMessage({
            payload: {
                target: '*',
                ...Loader.creators.loaderIsNotFetching(),
            },
        }))

        yield put(Internal.creators.sendMessage({
            payload: {
                target: '*',
                ...Loader.creators.getLoaderSuccess({
                    scope,
                    data: scopedLoader,
                }),
            },
        }))

        const adBlocked = yield adBlockDetector()
        const decoratorPayload = yield select(selectors.decoratorPayload, adBlocked)

        const picoInit = yield select(selectors.hasPicoInitialed)
        const userWindowObject = yield select(Loader.selectors.userWindowObject)

        if (!picoInit) {
            yield initializeDecorators(decoratorPayload)

            events.update(userWindowObject, 'PICO/LOADED')

            yield put(creators.picoInit({ origin: 'loader' }))
        } else {
            yield updateDecorators(decoratorPayload)

            events.update(userWindowObject, 'PICO/UPDATED')
        }
    }

    yield call(handleArticle)

    const executePostLoaderActions = yield select(selectors.executePostLoaderActions)

    // console.log('executePostLoaderActions', executePostLoaderActions)

    if (executePostLoaderActions) {
        // yield call(handlePrompt)
    }
}

export function* watchLoaderError() {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...Loader.creators.loaderIsNotFetching(),
        },
    }))

    yield put({
        type: 'AUTH/LOGOUT',
    })
}

export function* watchLoaderRequest() {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: '*',
            ...Loader.creators.loaderIsFetching(),
        },
    }))
}
